/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BillingInputs */

const he_nav_billing = /** @type {(inputs: Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיוב`)
};

const en_nav_billing = /** @type {(inputs: Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Nav_BillingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_billing = /** @type {((inputs?: Nav_BillingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BillingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_billing(inputs)
	return en_nav_billing(inputs)
});